import { useState, useEffect } from 'react';
import { DocumentData } from 'firebase/firestore';
import { subscribeToCollection } from '../services/firestoreService';

export const useCollection = <T extends DocumentData>(
  collectionName: string,
  orderField: string = "createdAt",
  limitCount: number = 50
) => {
  const [data, setData] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = subscribeToCollection<T>(
      collectionName,
      (docs) => {
        setData(docs);
        setLoading(false);
      },
      orderField,
      limitCount
    );

    return () => unsubscribe();
  }, [collectionName, orderField, limitCount]);

  return { data, loading };
};
